import { PricePlanTypeEnum } from 'common/enums/PricePlanTypeEnum'
import type {
  LimitedSubscriptionPlan,
  OneShotPlan,
  PricePlan,
  SubscriptionPlan,
} from 'common/types/OfferInterface'
import { TypedTFunctionInterface } from 'src/shared/i18next/types/typed-t-function-interface'

export const isOneShot = (plan?: PricePlan): plan is OneShotPlan =>
  plan?.type === PricePlanTypeEnum.OneShot

export const isSubscriptionPlan = (
  plan?: PricePlan,
): plan is SubscriptionPlan => plan?.type === PricePlanTypeEnum.Subscription

export const isLimitedSubscriptionPlan = (
  plan?: PricePlan,
): plan is LimitedSubscriptionPlan =>
  plan?.type === PricePlanTypeEnum.LimitedSubscription

export type PriceFormatter = (formattedAmount: string) => string
export const getPriceFormatter = (
  pricePlan: PricePlan | undefined,
  t: TypedTFunctionInterface,
): PriceFormatter | undefined => {
  if (isOneShot(pricePlan) || !pricePlan) {
    return undefined
  }

  const {
    intervalCount,
    interval,
    trialPeriod,
    trialInterval,
    limitOfPayments,
  } = (pricePlan as LimitedSubscriptionPlan | SubscriptionPlan).subscriptionPlan

  const trial = trialPeriod
    ? t('components.offer_price.free_trial_for', {
        unit: trialInterval,
        count: trialPeriod,
      })
    : undefined

  let intervalPart: string | undefined
  if (intervalCount) {
    const everyStr = t('components.offer_price.payment_every', {
      unit: interval,
      count: intervalCount,
    })
    intervalPart = limitOfPayments
      ? `${everyStr} – ${t('components.offer_price.payment_times', { count: limitOfPayments })}`
      : everyStr
  }

  if (trial && intervalPart) {
    return formattedAmount => `${trial} ${formattedAmount} ${intervalPart}`
  }
  const staticPart = trial ?? intervalPart

  if (!staticPart) {
    return (formattedAmount: string) => formattedAmount
  }

  return formattedAmount => `${formattedAmount} ${staticPart}`
}
